import styled from 'styled-components'
import { Image } from 'antd'

export const StyledImage = styled(Image)`
  object-fit: cover;
  cursor: pointer;
`
